import { render, staticRenderFns } from "./FormAlerts.vue?vue&type=template&id=5f62fede&"
import script from "./FormAlerts.vue?vue&type=script&lang=js&"
export * from "./FormAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports